/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React               from 'react';
import { Switch, Route }   from 'react-router-dom';
import { injectGlobal }    from 'styled-components';
import { Home }            from './pages/Home';
import { Pricing }         from './pages/Pricing';
import { About }           from './pages/About';
import { Contact }         from './pages/Contact';
import { NotFound }         from './pages/NotFound';
import BackgroundPattern   from '../images/pattern-houses.png';
import Background2xPattern from '../images/pattern-houses@2x.png';
import { Colours }         from '../styles/variables';
import '../styles/common.css';


/*********************************************************************************
 2. Component
 *********************************************************************************/

injectGlobal([`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Lato', 'Roboto', sans-serif;
    background-repeat: repeat;
    background-attachment: fixed;
    background-color: ${Colours.Alabaster};
    background-image: url(${BackgroundPattern});
    @media only screen and (-webkit-min-device-pixel-ratio: 1.3),
           only screen and (min--moz-device-pixel-ratio: 1.3),
           only screen and (-o-min-device-pixel-ratio: 1.3/1),
           only screen and (min-resolution: 125dpi),
           only screen and (min-resolution: 1.3dppx) {
               background-image: url(${Background2xPattern});
               background-size: 300px 300px;
    }
`]);

export const App = () => (
    <Switch>
        <Route exact path="/" component={Home}/>
        <Route path="/pricing" component={Pricing}/>
        <Route path="/about" component={About}/>
        <Route path="/contact" component={Contact}/>
        <Route component={NotFound}/>
    </Switch>
);



// WEBPACK FOOTER //
// ./src/components/App.js